<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    let userInfo = window.localStorage.getItem("userInfo");
    if (userInfo) {
      this.$store.commit("user/SET_NAME", JSON.parse(userInfo).name || "");
      this.$store.commit("user/SET_AVATAR", JSON.parse(userInfo).headimg || "");
      this.$store.commit("user/SET_TELPHONE", JSON.parse(userInfo).telphone || "");
      this.$store.commit("user/SET_POSITION", JSON.parse(userInfo).position || "");
      this.$store.commit("user/SET_GENDER", JSON.parse(userInfo).gender || "");
      this.$store.commit("user/SET_BIRTHADY", JSON.parse(userInfo).birthday || "");
      this.$store.commit("user/SET_LASTLOGINTIME", JSON.parse(userInfo).lastlogintime || "");
    } 
    // 监听全局事件，关闭所有弹窗
    this.openminprogram();
  },
  methods: {
    // 关闭所有弹窗的方法
    async openminprogram() {
      let res1 = await this.post("system.openminprogram", {});
      if (res1 && res1.data)
        window.localStorage.setItem("imgDomain", res1.data.imgDomain);
    },
  },
};
</script>

<style lang="scss">
.popperclass {
  z-index: 999999 !important;
}
</style>
